var render = function render(){var _vm=this,_c=_vm._self._c;return _c('object',{attrs:{"data":_vm.url,"type":"application/pdf","width":"100%","height":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }